var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgFilterNew = function SvgSvgFilterNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.501 18.75a3.016 3.016 0 0 1-2.902-2.25H5.251a.75.75 0 0 1 0-1.5H7.6a3.014 3.014 0 0 1 2.9-2.25c1.371 0 2.565.947 2.903 2.25h5.348a.75.75 0 0 1 0 1.5h-5.348a3.016 3.016 0 0 1-2.902 2.25Zm-.001-4.5a1.501 1.501 0 0 0 .001 3c.827 0 1.5-.673 1.5-1.5s-.673-1.5-1.501-1.5v-.375.375ZM16.5 11.25A3.017 3.017 0 0 1 13.6 9H5.251a.75.75 0 0 1 0-1.5h8.348a3.016 3.016 0 0 1 2.902-2.25c1.654 0 3 1.346 3 3a3.005 3.005 0 0 1-3.001 3Zm.001-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgSvgFilterNew;